import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../../component/BreadCrumb';
import TextEditor from '../../../../component/editor/TextEditor';
import InputBox from '../../../../component/InputBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import { actionAdd } from '../../../../module/body/community/faq/CommunityFaqModule';
import { VIEW_COMMUNITY_FAQ_ADD } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import { COMMUNITY_FAQ_PATH, ROLE } from '../../../../constant/Constant';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import PopupRef from '../../../../component/PopupRef';

const CommunityFaqAddView = () => {
    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);

    const [postingNo, setPostingNo] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [addPermission, setAddPermission] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN || AuthenticationUtil.getUserRoleCd() == ROLE.STAFF) {
            setAddPermission(true);
        } else {
            popupRef.current.openAlert('FAQ 등록 권한이 부족합니다. FAQ 목록 조회 화면으로 이동합니다.', () => {
                return function () {
                    navigate(COMMUNITY_FAQ_PATH);
                };
            });
        }
    }, []);

    const handleCancel = () => {
        navigate(COMMUNITY_FAQ_PATH);
    };

    const handleConfirm = () => {
        if (validateFaq()) {
            dispatch(
                actionAdd({
                    params: {
                        postingTitleNm,
                        postingCtnt,
                    },
                    callback: (pno) => {
                        popupRef.current.openInfo(
                            '게시물 번호 ' + pno + '이 등록되었습니다. FAQ 목록으로 이동합니다.',
                            () => {
                                return function () {
                                    navigate(COMMUNITY_FAQ_PATH);
                                };
                            },
                        );
                    },
                }),
            );
        }
    };

    const validateFaq = () => {
        if (!addPermission) {
            popupRef.current.openAlert('로그인하신 사용자의 권한이 부족합니다.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingTitleNm)) {
            popupRef.current.openAlert('제목을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingCtnt)) {
            popupRef.current.openAlert('내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>FAQ</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_FAQ_ADD.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_FAQ_ADD.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    {/* <h3 className='cmnty-title'>FAQ 등록</h3> */}
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                placeholder='제목을 입력하세요.'
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                    </div>
                    <TextEditor className='cmnty-wrt-box' value={postingCtnt} onChange={setPostingCtnt} />
                    <div className='cmnty-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityFaqAddView;
